import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Student } from '../models/student.model';
import { environment } from 'src/environments/environment';
import * as globals from '../training/globals';

const baseUrl = `${environment.apis.connect}/${globals.STUDENTS}`;

@Injectable({
  providedIn: 'root',
})

export class StudentsService {
  constructor(
    private http: HttpClient) { }

  getStudents(): Observable<Student[]> {
    return this.http.get<Student[]>(`${baseUrl}/${globals.GET_STUDENTS}`);
  }

  getStudentById(id: number): Observable<Student> {
    return this.http.get<Student>(`${baseUrl}/${globals.GET_STUDENT_BY_ID}?id=${id}`);
  }
  
  getStudentsByClassId(class_id: number): Observable<Student[]> {
    return this.http.get<Student[]>(`${baseUrl}/${globals.GET_STUDENTS_BY_CLASS_ID}?${globals.CLASS_ID}=${class_id}`);
  }
  
  getStudentsCdsInUseByClassId(class_id: number): Observable<Student[]> {
    return this.http.get<Student[]>(`${baseUrl}/${globals.GET_STUDENTS_CDS_IN_USE_BY_CLASS_ID}?${globals.CLASS_ID}=${class_id}`);
  }

  getStudentsCountByClassId(class_id: number): Observable<number> {
    return this.http.get<number>(`${baseUrl}/${globals.GET_STUDENTS_COUNT_BY_CLASS_ID}?${globals.CLASS_ID}=${class_id}`);
  }
  
  isStudentInUse(account_id: string, student_id: number): Observable<boolean> {
    return this.http.get<boolean>(`${baseUrl}/${globals.IS_STUDENT_IN_USE}?${globals.ACCOUNT_ID}=${account_id}&student_id=${student_id}`);
  }

  create_student(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.CREATE_STUDENT}`, data);
  }

  update_student(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.UPDATE_STUDENT}`, data);
  }

  delete_student(id: number): Observable<any> {
    return this.http.delete(`${baseUrl}/${globals.DELETESTUDENT}/${id}`);
  }

  resetStudentStatus(id: number): Observable<boolean> {
    return this.http.post<boolean>(`${baseUrl}/${globals.RESETSTUDENT}/${id}`, null);
  }

  update_cds(data: any): Observable<any> {
    return this.http.put(`${baseUrl}/${globals.UPDATE_CDS_STATUS}`, data);
  }

  resetBackfillDate(data: any): Observable<boolean> {
    return this.http.post<boolean>(`${baseUrl}/${globals.RESETBACKFILLDATE}`, data);
  }
  
}
